import React from "react";
import SliderCorousel from "./CardSlider";
import StrategySection from "./StrategySection";
import AIImage from "../../assets/ai.webp";
import CheckboxIcon from "../../assets/check-box.png";
import Milestones from "./Milestones";
import HeroSection from "./HeroSection";

const HeroSec = () => {
  return (
    <div style={{ backgroundColor: "#e6e4e4" }}>
      <HeroSection />

      <Milestones />
      {/* <div style={{ marginBottom: "10px" }}>
        <SliderCorousel />
      </div> */}

      <StrategySection imageSrc={AIImage} checkboxIcon={CheckboxIcon} />
    </div>
  );
};

export default HeroSec;
